var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
export var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  width: 30px;\n  height: 30px;\n  padding: 2px;\n  margin: 5px 5px 0 0;\n  img {\n    width: 25px;\n    height: 25px;\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  width: 30px;\n  height: 30px;\n  padding: 2px;\n  margin: 5px 5px 0 0;\n  img {\n    width: 25px;\n    height: 25px;\n    ", "\n  }\n"])), function (_a) {
    var archived = _a.archived;
    return archived ? greys.lightest : greys.white;
}, greys.light, function (_a) {
    var archived = _a.archived;
    return archived && "opacity: .3;";
});
var templateObject_1;
